import React from 'react';

interface MediaButtonProps {
  text: string;
  className?: string;
  ariaLabel?: string;
  icon: string;
  style?: React.CSSProperties;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const MediaButton = ({ text, className, ariaLabel, icon, style, onClick }: MediaButtonProps) => (
  <button
    type="button"
    data-am-mediabutton=""
    onClick={onClick}
    className={className}
    aria-label={ariaLabel}
    style={style}
  >
    <div className="media-button">
      <span className="media-button-icon">
        <i className={`no-margin icon-${icon}`} />
      </span>
      <span className="media-button-text">{text}</span>
    </div>
  </button>
);

export default MediaButton;
